import { useMemo as o } from "react";
import { useWindowSize as r } from "./useWindowSize.js";
const t = 769, i = 1024;
var n = /* @__PURE__ */ ((e) => (e.Desktop = "desktop", e.Tablet = "tablet", e.MobileApp = "mobileApp", e.Mobile = "mobile", e))(n || {});
const u = () => {
  const {
    width: e
  } = r();
  return o(() => navigator.userAgent.includes("PartooMobileApp") ? "mobileApp" : e && t <= e && e <= i ? "tablet" : e && t > e ? "mobile" : "desktop", [e]);
};
export {
  n as DeviceType,
  i as MAX_TABLET_WIDTH,
  t as MIN_TABLET_WIDTH,
  u as useDeviceType
};
